import loadable from '@loadable/component'
import { Col, Row } from '@uswitch/ev-core/react'
import { useThemeUI } from 'theme-ui'

const ConnectedGuideCard = loadable(() => import('./connected-guide-card'))

const Default = ({ linkedUrls }) => {
  const { theme } = useThemeUI()

  return (
    <div sx={{ width: '100%' }}>
      <If condition={linkedUrls}>
        <Row cols={theme?.compounds?.card?.itemsPerRow} wrap>
          <For index='key' each='url' of={linkedUrls}>
            <Col span={1} key={key}>
              <ConnectedGuideCard entity={url} showDescription />
            </Col>
          </For>
        </Row>
      </If>
    </div>
  )
}

export default Default
